import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'

import { RejectError } from '../../typings'

/**
 * Update region
 *
 * @private
 */
export const updateTrafficProfile = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  uui.domain.client.rm.TrafficProfile,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/traffic/updateTrafficProfile', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()
    const response = await rpc('rpc/traffic/updateTrafficProfile', {
      category: 'rpc',
      type: 'rpc/traffic/updateTrafficProfile',
      trafficProfile: payload,
    })
    if (response.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: response.errorMessage,
        error: response,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {updateTrafficProfile}`,
      { tags: ['rpc', 'traffic'], info: payload },
      'error',
    )
    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Update traffic profile failed`,
      error,
    })
  }
})
